import React from 'react';
import { VideoIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-brand-dark" data-id="element-169" data-mp="3oavdixl9emvy">
      <div className="mx-auto max-w-letter px-4 py-7 text-center sm:px-6 sm:py-8" data-id="element-170" data-mp="3j9xvqm45vuuz">
        <p className="text-[0.68rem] font-extrabold uppercase tracking-[0.14em] text-gold" data-id="element-171" data-mp="142rxhpax502">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-xl uppercase leading-[1.1] tracking-tight text-white sm:text-3xl" data-id="element-172" data-mp="3t6anheg5byn3">
          6 tomos en un solo sistema, creados para aprender desde cero.
        </h2>
        <p className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-white px-3 py-1.5 text-[0.7rem] font-extrabold uppercase leading-tight tracking-tight text-brand sm:text-sm" data-id="element-173" data-mp="krsdv8ak4b1d">
          <VideoIcon size={14} className="flex-shrink-0" aria-hidden="true" data-id="element-174" data-mp="36avuhb5b57a6" />
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm font-medium leading-snug text-ink-onDarkMuted" data-id="element-175" data-mp="3b8xblqj6awj0">
          No es simplemente otro ebook de seguridad. Es una ruta de aprendizaje
          que organiza los conocimientos fundamentales para que comprendas qué
          aprender primero, qué viene después y cómo realizar instalaciones de
          forma más profesional.
        </p>

        <ol className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-176" data-mp="3u8b5y9kte9a1">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full gap-3 rounded-lg bg-white p-3.5 text-left" data-id="element-177" data-mp="2u5jehuvc41m" data-mpi={i}>
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-brand font-display text-lg leading-none text-white" aria-hidden="true" data-id="element-178" data-mp="butwnacfu0dg">
                {i + 1}
              </span>
              <div data-id="element-179" data-mp="2cuqg35ojg81t">
                <p className="text-[0.6rem] font-extrabold uppercase tracking-[0.14em] text-alert" data-id="element-180" data-mp="27xqaevvlp7b8">
                  Tomo {i + 1}
                </p>
                <h3 className="mt-0.5 text-[0.82rem] font-extrabold uppercase leading-tight tracking-tight text-brand-dark" data-id="element-181" data-mp="2mnea5so4vxwu">
                  {tomo.title}
                </h3>
                <p className="mt-1 text-[0.8rem] font-medium leading-snug text-ink-muted sm:text-sm" data-id="element-182" data-mp="2vmj74uk1rj6w">
                  {tomo.desc}
                </p>
              </div>
            </Reveal>)}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-183" data-mp="35k5qpucajyx7">
          Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}